import Box from '@/components/UI/box/Box';
import styles from './NeighbourhoodsItems.module.scss';
import { Control, Controller, UseFormSetValue, useWatch } from 'react-hook-form';
import { FC } from 'react';
import Checkbox from '@/components/UI/checkbox/Checkbox';
import { NeighbourhoodsData } from '../../MidTermNeighbourhoods';
interface Props {
  data: any;
  control: Control<NeighbourhoodsData>;
  handleValue: UseFormSetValue<NeighbourhoodsData>;
}
const NeighbourhoodsItems: FC<Props> = ({
  data,
  control,
  handleValue
}) => {
  const village = useWatch({
    control,
    name: 'village'
  }) || [];
  const toggleVillage = (item: string) => {
    const isChecked = Array.isArray(village) && village.includes(item);
    const updated = isChecked ? village.filter(v => v !== item) : [...(Array.isArray(village) ? village : [village]), item];
    handleValue('village', updated.length ? updated : undefined);
  };
  return <Box className={styles['neighbourhoods-items-container']} data-sentry-element="Box" data-sentry-component="NeighbourhoodsItems" data-sentry-source-file="NeighbourhoodsItems.tsx">
      {data?.map(item => <Controller key={item} name={item} control={control} render={({
      field: {
        value = false,
        onChange,
        ...props
      }
    }) => <Box>
              <Checkbox checked={village.includes(item)} label={item} onChange={() => toggleVillage(item)} {...props} />
            </Box>} />)}
    </Box>;
};
export default NeighbourhoodsItems;